import { render } from "./EncodeDecode.vue?vue&type=template&id=35848aa2"
import script from "./EncodeDecode.vue?vue&type=script&lang=js"
export * from "./EncodeDecode.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/encodedecode/encodedecode/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__